<div mat-dialog-title>
  <h2>{{ (data.record ? 'profile.updateCvResume' : 'profile.addCvResume')
    | translate }}</h2>
  <button type="button" class="close" aria-label="Close" mat-dialog-close>
    <mat-icon class="pop-close">close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div class="mat-dialog-body">
    <app-file-manager class="one-col" [files]='files' [maxSize]='10' [maxFiles]="1" [isRequired]="true"
      [isSubmitted]="isSubmited" [allowedExt]="['DOC', 'DOCX', 'pdf']"
      (selectedFiles)="files = $event"></app-file-manager>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button type="button" [disabled]="loading" mat-dialog-close class="btn-grey">
    {{"forms.Cancel" | translate}}
  </button>

  <button mat-raised-button color="primary" (click)="saveRecord()" [ngClass]="{ 'loading': loading}">
    <span>{{ (data.record ? 'profile.updateCvResume' : 'profile.addCvResume')
      | translate }}</span>
  </button>
</mat-dialog-actions>